import { buildClientSchema } from "graphql";
import introspection from "src/gql/introspection.json";

/** @ts-ignore https://github.com/graphql/graphql-js/issues/3409 */
export const graphqlSchema = buildClientSchema(introspection);
